import { ISODateString } from "@smartrr/shared/entities/ISODateString";

import { typedCustomerFrontendApi } from "@customer-app/shared/typedCustomerFrontendApi";
import { customerAsyncDispatch } from "@customer-app/state/customerAsyncDispatch";
import { CustomerThunkAction } from "@customer-app/state/typedCustomerRedux";

export const updateCustomersBirthday =
  (
    customerRelationshipId: string,
    birthdayDate: ISODateString
  ): CustomerThunkAction<
    | "LOADING_UPDATE_CUSTOMERS_BIRTHDAY"
    | "ERROR_UPDATING_CUSTOMERS_BIRTHDAY"
    | "SUCCESS_UPDATING_CUSTOMERS_BIRTHDAY"
  > =>
  dispatch =>
    customerAsyncDispatch(
      typedCustomerFrontendApi.putReq("/customer-relationship/:customerRelationshipId/birthday", {
        params: { customerRelationshipId },
        reqBody: { birthdayDate },
      }),
      () =>
        dispatch({
          type: "LOADING_UPDATE_CUSTOMERS_BIRTHDAY",
          payload: undefined,
        }),
      error =>
        dispatch({
          type: "ERROR_UPDATING_CUSTOMERS_BIRTHDAY",
          payload: {
            errorMessage: error.message,
          },
        }),
      updatedBirthdayDate =>
        dispatch({
          type: "SUCCESS_UPDATING_CUSTOMERS_BIRTHDAY",
          payload: updatedBirthdayDate,
        })
    );
